import { render, staticRenderFns } from "./HistoricoEtapas.vue?vue&type=template&id=7ee40b2e"
import script from "./HistoricoEtapas.vue?vue&type=script&lang=ts"
export * from "./HistoricoEtapas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports